// extracted by mini-css-extract-plugin
export default {"container":"support-page_container__x0VF3","mainText":"support-page_mainText__gTayc","helpCenter":"support-page_helpCenter__mw0Y1"};